// extracted by mini-css-extract-plugin
module.exports = {"action":"Signup_action__3nWZ5","label":"Signup_label__PfJII","forgotPassword":"Signup_forgotPassword__FFJiB"};